export default {
  baseUrl: {
    'dev': 'https://cn3.api.xcthings.com:6008',
    'alp': 'https://cn3.api.xcthings.com:6008',
    'pro': 'https://cn3.api.xcthings.com:6008'
    // 'dev': 'http://172.24.153.82:8009',
    // 'alp': 'http://172.24.153.82:8009',
    // 'pro': 'http://172.24.153.82:8009'
  },
  dataIp: '172.24.153.83',
  // pro
  // uploadUrl: 'http://172.24.153.82:9302/upload',
  // downUrl: 'http://172.24.153.82:9302/down',
  // dev
  uploadUrl: 'http://120.25.165.80:9302/upload',
  downUrl: 'http://120.25.165.80:9302/down',
  /**
   * client 配置
   */
  client: {
    ClientSeckey: '4jn3uMqBoDfWbhXxBSBYEDOo6KOmJU6q',
    client_id: 'mVM8WAnlfoVOuVGWPEr9Yv7mCQT6JKil'
  },
  //微信公众平台appid
  appid:'wxa6039b9782b097fa',
  /**
   * 登录参数配置
   */
  app_login: {
    login_type: 2,
    app_code: '80011006'
  },
  // 简阳
  mapCenter: [104.5391, 30.4132]
}
